import { render, staticRenderFns } from "./ZhanhuiRankedByJbsj.vue?vue&type=template&id=fc768090&scoped=true"
import script from "./ZhanhuiRankedByJbsj.vue?vue&type=script&lang=js"
export * from "./ZhanhuiRankedByJbsj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc768090",
  null
  
)

export default component.exports